import { postTaggingEnrollment } from '../api/spm';
export default async (force = false, logger) => {
    return await postTaggingEnrollment({}, force, logger);
};
